import { AxiosInstance } from 'axios';

import { APIManagerConfig } from '../apiManager';
import { BinControlUnit } from '../../../store/entities/binControl/binControl.types';

const BinControlServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getBinControlUnitsList: (): Promise<BinControlUnit[]> =>
      HTTPBase.get(`farm/${config.farmId}/bincontrol/units`).then((res) => res.data),
    createBinControlUnitsList: (payload: Partial<BinControlUnit>): Promise<BinControlUnit> =>
      HTTPBase.post(`farm/${config.farmId}/bincontrol/units`, payload).then((res) => res.data),
    editBinControlUnitsList: (id: string, payload: Partial<BinControlUnit>): Promise<BinControlUnit> =>
      HTTPBase.patch(`farm/${config.farmId}/bincontrol/units/${id}`, payload).then((res) => res.data),
    deleteBinControlUnitsList: (id: string) =>
      HTTPBase.delete(`farm/${config.farmId}/bincontrol/units/${id}`).then((res) => res.data),
  };
};

export default BinControlServiceFactory;
